import { render, staticRenderFns } from "./ListAsssintance.vue?vue&type=template&id=dadff620&"
import script from "./ListAsssintance.vue?vue&type=script&lang=js&"
export * from "./ListAsssintance.vue?vue&type=script&lang=js&"
import style0 from "./ListAsssintance.vue?vue&type=style&index=0&id=dadff620&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports